// src/components/Footer.js
import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.css"; // optional, for styling

function Footer() {
    return (
      <footer className="footer">
        <p>
          © 2026{" "}
          <a
            href="https://www.retreeval.com"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Retreeval Technologies Limited
          </a>{" "}
          | <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>{" "}
          | <Link to="/terms" className="footer-link">Terms</Link>
        </p>
      </footer>
    );
  }
  
export default Footer;
  